/**
 * pdf.js v6 decodes JBIG2/CCITT, JPEG 2000 and ICC profiles, and loads CMaps
 * and standard fonts, from plain directories at runtime. `wasmUrl` has no
 * default in the API, so without these the scanned-image decoders throw
 * `JBig2Error: JBig2 failed to initialize`. The trailing slash is required by
 * pdf.js (`Invalid factory url` otherwise). The directories are emitted by the
 * `viteStaticCopy` target in `vite.config.ts`.
 */
const pdfjsAssetBase = `${import.meta.env.BASE_URL}pdfjs/`;

export type PdfJsAssetOptions = {
  wasmUrl: string;
  cMapUrl: string;
  cMapPacked: boolean;
  standardFontDataUrl: string;
  iccUrl: string;
};

export const pdfjsAssetOptions: PdfJsAssetOptions = {
  wasmUrl: `${pdfjsAssetBase}wasm/`,
  cMapUrl: `${pdfjsAssetBase}cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: `${pdfjsAssetBase}standard_fonts/`,
  iccUrl: `${pdfjsAssetBase}iccs/`,
};
